module.exports = __webpack_public_path__ + "img/jcb.d492b35c.svg";